import CheckboxField from "./CheckboxField";
const CookieRow = (props) => {
  return (
    <>
      {" "}
      <div style={{ display: "flex", marginBottom: "1em" }}>
        {" "}
        <div style={{ paddingRight: "1em" }}>
          {" "}
          <CheckboxField
            checked={props.checked}
            onChange={props.handleChange}
            disabled={props.disabled}
          />{" "}
        </div>{" "}
        <div>
          {" "}
          <strong>{props.title}</strong>{" "}
          <div style={{ fontSize: "20px" }}>{props.description}</div>{" "}
        </div>{" "}
      </div>{" "}
    </>
  );
};
export default CookieRow;
